import React from 'react';

import { Select, SelectContent, SelectItem, SelectTrigger } from '@column/ui';

// Radix Select can't hold an empty-string value, so the "all" option (value '') maps to this sentinel.
const ALL_SENTINEL = 'all';

export interface StatusFilterOption {
  label: string;
  value: string;
}

interface StatusFilterSelectProps {
  value: string;
  onChange: (value: string) => void;
  options: StatusFilterOption[];
  placeholder?: string;
  className?: string;
}

export const StatusFilterSelect: React.FC<StatusFilterSelectProps> = ({
  value,
  onChange,
  options,
  placeholder = 'Status',
  className,
}) => {
  const triggerLabel = value === '' ? placeholder : (options.find((option) => option.value === value)?.label ?? value);

  return (
    <Select value={value || ALL_SENTINEL} onValueChange={(next) => onChange(next === ALL_SENTINEL ? '' : next)}>
      <SelectTrigger size="sm" variant="card" className={className}>
        {triggerLabel}
      </SelectTrigger>
      <SelectContent align="end" position="popper">
        {options.map((option) => (
          <SelectItem key={option.value || ALL_SENTINEL} value={option.value || ALL_SENTINEL}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
